export const isClientAccessActive = (
  accessStartAt?: string | null,
  accessEndAt?: string | null,
  referenceDate: Date = new Date(),
): boolean => {
  const referenceTime = referenceDate.getTime();

  if (accessStartAt) {
    const startTime = new Date(accessStartAt).getTime();
    if (Number.isFinite(startTime) && referenceTime < startTime) {
      return false;
    }
  }

  if (accessEndAt) {
    const endTime = new Date(accessEndAt).getTime();
    if (Number.isFinite(endTime) && referenceTime > endTime) {
      return false;
    }
  }

  return true;
};
